import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

import { nonemptySchema } from '@utils/schema';

export const SIGN_UP_CONFIG = {
  resolver: zodResolver(
    z
      .object({
        name: nonemptySchema,
        company: nonemptySchema,
        username: nonemptySchema,
        email: nonemptySchema.email({ message: 'Email invalido' }),
        password: nonemptySchema,
        confirmPassword: nonemptySchema,
        role: nonemptySchema,
      })
      .refine((data) => data.password === data.confirmPassword, {
        message: 'Senha diferente',
        path: ['confirmPassword'],
      })
  ),
  defaultValues: {
    name: '',
    company: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: '',
  },
};
